<template src="./configuratore.html">
    
</template>

<script>
export default {
    
}
</script>